import styled from 'styled-components';
export const BlurredItemWrapper = styled.div `
  position: relative;
`;
export const BlurredContent = styled.div `
  filter: blur(5px);
  -webkit-filter: blur(5px);
  pointer-events: none;
`;
export const LockOverlayCard = styled.div `
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: ${({ theme }) => theme.colors.beige_2};
  border: 1px solid ${({ theme }) => theme.colors.grey_2};
  border-radius: 6px;
  padding: 24px;
  width: min(85%, 760px);
  box-shadow: 0px 6px 11px rgba(0, 0, 0, 0.12);
  pointer-events: auto;
  text-align: center;
  z-index: 1;
`;
